<div
  class="buttons-container"
  style="
    display: flex;
    justify-content: end;
    right: 45px;
    position: relative;
    top: 30px;
  "
>
  <div class="buttons" id="code-buttons">
    <dx-button
      icon="plus"
      type="success"
      text="YENİ EKLE"
      class="margin"
      (onClick)="openEditor()"
    ></dx-button>
    <dx-button
      *ngIf="isVisibleEditor"
      icon="remove"
      type="success"
      text="EDİTÖRÜ GİZLE"
      stylingMode="outlined"
      class="margin"
      (onClick)="closeEditor()"
    ></dx-button>
  </div>
</div>
<div class="container"> <!-- /**content -->
  <h2 class="content-block">Sıkça Sorulan Sorular</h2>

  <div
    *ngIf="isVisibleEditor"
    class="content-block card responsive-paddings"
  >
  <label span class="dx-field-item-label-text">Başlık</label>
    <dx-text-box
      [(value)]="staticPageUpdateDto.title"
      labelMode="floating"
      [maxLength]="100"
    >
    </dx-text-box>
    <div *ngIf="submitted && !staticPageUpdateDto.title" class="validation-error">
      Bu alan zorunludur.
    </div>
    <br />
  <label span class="dx-field-item-label-text">MetaKeyword</label>
  <dx-text-box
    [(value)]="staticPageUpdateDto.metaKeyword"
    labelMode="floating"
  >
  </dx-text-box>
  <br />
  <label span class="dx-field-item-label-text">MetaDescription</label>
  <dx-text-box
    [(value)]="staticPageUpdateDto.metaDescription"
    labelMode="floating"
  >
  </dx-text-box>
  <br />
    <dx-html-editor
      [(value)]="staticPageUpdateDto.content"
      style="height: 300px"
    >
      <dxo-toolbar>
        <dxi-item name="undo"></dxi-item>
        <dxi-item name="redo"></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item
          name="size"
          [acceptedValues]="[
            '8pt',
            '9pt',
            '10pt',
            '12pt',
            '14pt',
            '18pt',
            '24pt',
            '36pt'
          ]"
          [options]="{ inputAttr: { 'aria-label': 'Font size' } }"
        ></dxi-item>
        <dxi-item
          name="font"
          [acceptedValues]="[
            'Arial',
            'Courier New',
            'Georgia',
            'Impact',
            'Lucida Console',
            'Tahoma',
            'Times New Roman',
            'Verdana'
          ]"
          [options]="{ inputAttr: { 'aria-label': 'Font family' } }"
        ></dxi-item>
        <dxi-item
          name="header"
          [acceptedValues]="[false, 1, 2, 3, 4, 5]"
          [options]="{ inputAttr: { 'aria-label': 'Header' } }"
        ></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item name="bold"></dxi-item>
        <dxi-item name="italic"></dxi-item>
        <dxi-item name="strike"></dxi-item>
        <dxi-item name="underline"></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item name="alignLeft"></dxi-item>
        <dxi-item name="alignCenter"></dxi-item>
        <dxi-item name="alignRight"></dxi-item>
        <dxi-item name="alignJustify"></dxi-item>
        <dxi-item name="orderedList"></dxi-item>
        <dxi-item name="bulletList"></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item name="link"></dxi-item>
        <dxi-item widget="dxButton" [options]="toolbarButtonOptions"></dxi-item>
      </dxo-toolbar>
    </dx-html-editor>
    <div *ngIf="submitted && !staticPageUpdateDto.content" class="validation-error">
      Bu alan zorunludur.
    </div>
<div class="city">
      
  <dx-button
  icon="save"
  type="success"
  text="Kaydet"
  class="margin"
  (onClick)="save()"
></dx-button>
</div>
  </div>

  <div id="accordion">
    <dx-accordion
      #accordion
      [dataSource]="dataSource"
      [collapsible]="true"
      [multiple]="false"
      [animationDuration]="300"
      [selectedItems]="[dataSource[0]]"
      class="content-block card responsive-paddings"
      [grouped]="true"
      [searchEnabled]="false"
      selectionMode="single"
      id="accordion-container"
    >
      <div *dxTemplate="let item of 'group'">
        <h2 class="name">{{ item.title }}</h2>
      </div>

      <div *dxTemplate="let item of 'item'">
        <p class="address" [innerHTML]="getShortContent(item.content)"></p>
        <div class="city">
          <dx-button
            icon="edit"
            type="success"
            text="Düzenle"
            class="margin"
            (onClick)="listSelectionChanged(item)"
          ></dx-button>
          <dx-button
            type="danger"
            text="Sil"
            class="margin"
            (onClick)="confirmDelete(item.id)"
          ></dx-button>
          <dx-button
            *ngIf="item.isWebSiteList"
            type="default"
            text="YAYINDAN KALDIR"
            class="margin"
            stylingMode="outlined"
            (onClick)="webListUpdate(item, false)"
          ></dx-button>
          <dx-button
            *ngIf="!item.isWebSiteList"
            type="default"
            text="YAYINLA"
            class="margin"
            stylingMode="outlined"
            (onClick)="webListUpdate(item, true)"
          ></dx-button>
        </div>
      </div>
    </dx-accordion>
    <dx-popup
    [showTitle]="true"
    title="Ön İzleme"
    [(visible)]="popupVisible"
    [showCloseButton]="true"
  >
    <h3>{{ staticPageUpdateDto.title }}</h3>
    <div [innerHTML]="staticPageUpdateDto.content"></div>
  </dx-popup>
  </div>
  <style>
    .validation-error {
      color: #dc3545;
      font-size: 0.875rem;
      margin-top: 4px;
    }
  </style>
</div>

<!-- Silme Onay Popup -->
<div *ngIf="showDeleteConfirm" class="delete-confirm-overlay">
  <div class="delete-confirm-popup">
    <div class="popup-header">
      <h3>Silme Onayı</h3>
    </div>
    <div class="popup-content">
      <p>Silmek istediğinize emin misiniz?</p>
    </div>
    <div class="popup-actions">
      <button (click)="cancelDelete()" class="button secondary">
        <span>İptal</span>
      </button>
      <button (click)="confirmDeleteItem()" class="button danger">
        <span>Sil</span>
      </button>
    </div>
  </div>
</div>
